'use client';

import { de, enUS, fr } from 'date-fns/locale';
import { formatInTimeZone } from 'date-fns-tz';
import { usePathname } from 'next/navigation';
import { memo, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ONE_MINUTE } from '@/helpers/dateTime';
import { Locale as ELocale } from '@/helpers/languages';

import { ScCasinoClockUTC } from './styled';

const LOCALE_MAP: Record<string, Locale> = {
  [ELocale.GERMAN]: de,
  [ELocale.FRENCH_CANADA]: fr,
  [ELocale.FRENCH_SWITZERLAND]: fr,
};

export const CasinoClockUTC = memo(() => {
  const [currentTime, setCurrentTime] = useState(() => new Date());
  const pathname = usePathname();
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const locale = LOCALE_MAP[language] || enUS;
  const isNoSticky = useMemo(
    () => pathname.includes('/profile-custom'),
    [pathname]
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, ONE_MINUTE);
    return () => clearInterval(timer);
  }, []);

  const utcString = useMemo(
    () =>
      formatInTimeZone(currentTime, 'UTC', 'EEE, MMM dd, HH:mm', {
        locale,
      }),
    [currentTime, locale]
  );

  return (
    <ScCasinoClockUTC isNoSticky={isNoSticky}>
      <div className="utc-clock">
        <span className="label">{t('casinoTime')}:</span>
        <span>
          <time className="utc">{utcString}</time> (UTC)
        </span>
      </div>
    </ScCasinoClockUTC>
  );
});
